import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Text, ActionButton, Spinner } from "@jds/core";
import { IcClose } from "@jds/core-icons";
import "../styles/pdfViewer.css";
import termsOfUseDoc from "url:../assets/TermsofUseCMS.pdf";
import privacyPolicyDoc from "url:../assets/PrivacyPracticeStatementCMS.pdf";

const PDFViewer = () => {
  const { documentType } = useParams();
  const navigate = useNavigate();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let url = null;

    if (documentType === "terms-of-use" || documentType === "terms") {
      url = termsOfUseDoc;
    } else if (documentType === "privacy-policy" || documentType === "privacy") {
      url = privacyPolicyDoc;
    }

    if (url) {
      setPdfUrl(url);
      setLoading(false);
    } else {
      setError("Document not found");
      setLoading(false);
    }
  }, [documentType]);

  useEffect(() => {
    if (!window._originalWindowOpen) {
      window._originalWindowOpen = window.open.bind(window);
    }

    const handlePDFLink = (url) => {
      if (url && typeof url === "string") {
        if (url.includes("/pdf/privacy-policy") || url.includes("/pdf/terms-of-use")) {
          if (url.includes("/pdf/privacy-policy")) {
            navigate("/pdf/privacy-policy");
            return true;
          }
          if (url.includes("/pdf/terms-of-use")) {
            navigate("/pdf/terms-of-use");
            return true;
          }
        }

        if (
          url.includes("PrivacyPracticeStatementCMS") ||
          url.includes("PrivacyPracticeStatement") ||
          url.endsWith("PrivacyPracticeStatementCMS.pdf") ||
          url.includes("/PrivacyPracticeStatementCMS.pdf")
        ) {
          navigate("/pdf/privacy-policy");
          return true;
        }
        if (
          url.includes("TermsofUseCMS") ||
          url.includes("TermsOfUse") ||
          url.endsWith("TermsofUseCMS.pdf") ||
          url.includes("/TermsofUseCMS.pdf")
        ) {
          navigate("/pdf/terms-of-use");
          return true;
        }
      }
      return false;
    };

    window.open = function (url, target, features) {
      if (handlePDFLink(url)) {
        return null;
      }
      return window._originalWindowOpen.call(this, url, target, features);
    };

    return () => {
      window.open = window._originalWindowOpen;
    };
  }, [navigate]);

  const handleClose = () => {
    navigate(-1);
  };

  const documentTitle =
    documentType === "terms-of-use" || documentType === "terms"
      ? "Terms of Use"
      : documentType === "privacy-policy" || documentType === "privacy"
        ? "Privacy Policy"
        : "Document";

  if (loading) {
    return (
      <div className="pdf-viewer-container">
        <div className="pdf-viewer-loading">
          <Spinner size="large" />
          <Text appearance="body-m" color="primary-grey-60">
            Loading document...
          </Text>
        </div>
      </div>
    );
  }

  if (error || !pdfUrl) {
    return (
      <div className="pdf-viewer-container">
        <div className="pdf-viewer-error">
          <Text appearance="heading-s" color="primary-grey-100">
            Document Not Found
          </Text>
          <Text appearance="body-m" color="primary-grey-80">
            {error || "The requested document could not be loaded."}
          </Text>
          <ActionButton
            label="Go Back"
            onClick={handleClose}
            kind="primary"
            size="medium"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-viewer-container">
      <div className="pdf-viewer-header">
        <Text appearance="heading-s" color="primary-grey-100">
          {documentTitle}
        </Text>
        <ActionButton
          icon={<IcClose />}
          onClick={handleClose}
          kind="tertiary"
          size="medium"
          label="Close"
        />
      </div>
      <div className="pdf-viewer-content">
        <iframe
          src={pdfUrl}
          title={documentTitle}
          className="pdf-iframe"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </div>
    </div>
  );
};

export default PDFViewer;
